import { CollectionReference, DocumentData, collection } from "firebase/firestore";
import { firestore } from "./firebase";


// helper for type safety
// see https://plainenglish.io/blog/using-firestore-with-typescript-in-the-v9-sdk-cf36851bb099
export const createCollection = <T = DocumentData>(collectionName: string) => {
    return collection(firestore, collectionName) as CollectionReference<T>
  }

  // clean undefined properties from any object because firestore cannot handle them.
export function removeUndefinedProperties<T>(obj: T): Partial<T> {
    const newObj: Partial<T> = {}; // Create a new object to store properties without undefined values
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined) {
            newObj[key] = obj[key]; // Copy non-undefined properties to the new object
        }
    }
    return newObj;
}
